import { CbInputModule } from '@chubb/ui-components/cb-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';
@NgModule({
    imports: [
        CommonModule,
        CbInputModule,
        ReactiveFormsModule,
        FormsModule,
        AppAnalyticsModule,
    ],
    declarations: [FooterComponent],
    exports: [FooterComponent],
})
export class FooterModule {}
